module.exports = __webpack_public_path__ + "static/img/partner-yxp.4d6c8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-yxp.png
// module id = Lr9b
// module chunks = 34